import { Icon } from '@hotjar/hotsauce';
import { LoadingScreen, SessionEnded } from '@hotjar/webapp/features/Playbacks';
import {
  cancelNextRecordingCountdown,
  hasNextRecording,
  hasPreviousRecording,
  nextRecording,
  onCreateFeedback,
  pause,
  play,
  previousRecording,
  readOnly,
  restart,
  togglePlayPause,
  updateWorthWatchingAnswer,
} from '@hotjar/recordings/src/features/Playbacks/utils';
import { useSelector, useStore, useStoreState } from '@hotjar/recordings/src/store/player/context';
import { useHelpHotjarUrl } from '@hotjar/translations';

export const PlaybackOverlays = (): JSX.Element => {
  const helpHotjarUrl = useHelpHotjarUrl();
  const playerStore = useStore();
  const { setShared } = useStoreState();
  const {
    playing,
    showLoader,
    recording,
    done,
    isShared,
    isSharedRecording,
    isWorthWatching,
    siteId,
    loaded,
    showHotjarLogo,
    isCancelledNextRecordingCountdown,
    isAutoplaying,
    showFeedbackPrompt,
  } = useSelector((state) => ({
    playing: state.playing,
    showLoader: state.showLoader,
    recording: state.recording,
    done: state.done,
    isShared: state.isShared,
    isSharedRecording: state.isSharedRecording,
    isWorthWatching: state.isWorthWatching,
    siteId: state.siteId,
    loaded: state.loaded,
    showHotjarLogo: state.showHotjarLogo,
    isCancelledNextRecordingCountdown: state.isCancelledNextRecordingCountdown,
    isAutoplaying: state.isAutoplaying,
    showFeedbackPrompt: state.showFeedbackPrompt,
  }));

  const showSessionEndBgDone = done && (showHotjarLogo || !isSharedRecording);

  return (
    <>
      <LoadingScreen isLoading={!loaded || showLoader} />

      <div id="preview-pause">
        <Icon icon="pause_alt" size="l" />
      </div>
      <div id="preview-play">
        <Icon icon="play_alt" size="l" />
      </div>

      {loaded ? (
        <div
          id="preview-overlay"
          className={[done ? 'show' : '', showLoader ? 'loading' : ''].join(' ')}
          onClick={(event) => togglePlayPause(playerStore, event, helpHotjarUrl)}
          aria-label="preview-overlay"
          aria-hidden="true"
        >
          {showSessionEndBgDone ? (
            <div className="background-done">
              <SessionEnded
                onShare={setShared}
                isTokenShared={isSharedRecording}
                isShared={isShared}
                isReadOnly={readOnly(playerStore)}
                isCancelledNextRecordingCountdown={isCancelledNextRecordingCountdown}
                onCancelNextRecording={() => cancelNextRecordingCountdown(playerStore)}
                onReplay={() => restart(playerStore)}
                isAutoplaying={isAutoplaying}
                recording={recording}
                hasPreviousRecording={hasPreviousRecording(playerStore)}
                onPrevious={() => previousRecording(playerStore)}
                hasNextRecording={hasNextRecording(playerStore)}
                onNext={() => nextRecording(playerStore)}
                onCreateFeedback={onCreateFeedback}
                showFeedbackPrompt={showFeedbackPrompt}
                siteId={siteId}
                onWorthWatchingAnswerChange={(answer: boolean | null) =>
                  updateWorthWatchingAnswer(playerStore, answer)
                }
                worthWatchingAnswer={isWorthWatching}
                isPlaying={playing}
                play={(showAnimation?: boolean) => play(playerStore, showAnimation)}
                pause={(showAnimation: boolean, manualPause: boolean) =>
                  pause(playerStore, showAnimation, manualPause)
                }
              />
            </div>
          ) : null}
        </div>
      ) : null}
    </>
  );
};
